export const INFO_TEXT_CURRENT_RISK =
  'The average risk that someone with your behaviors and medical history will develop cancer in their lifetime.';

export const INFO_TEXT_POTENTIAL_RISK =
  'Your potential risk if you complete all of the recommendations on your Action Plan.';

export const INFO_TEXT_POPULATION_AVERAGE_RISK =
  'The average risk that someone of your age and gender will develop cancer in their lifetime.';
